/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ChromeFeedRendererQueryVariables = {};
export type ChromeFeedRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ChromeFeed_viewer">;
    };
};
export type ChromeFeedRendererQuery = {
    readonly response: ChromeFeedRendererQueryResponse;
    readonly variables: ChromeFeedRendererQueryVariables;
};



/*
query ChromeFeedRendererQuery {
  viewer {
    ...ChromeFeed_viewer
    id
  }
}

fragment ChromeFeed_viewer on Viewer {
  user {
    givenName
    createdTime
    chromeExtensionFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    flowStates(first: 1000000) {
      edges {
        node {
          ...FastCrawlLoader_flowState
          flowKey
          current {
            state
            percentComplete
            errorMessage
            id
          }
          pending {
            state
            percentComplete
            errorMessage
            id
          }
          id
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          id
          ...FeedScheduler_org
          orgMeetingHours {
            workingHours {
              timeZone
              id
            }
            id
          }
          experiments
          primaryTeam {
            __typename
            ... on Team {
              teamId
              teamName
            }
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          featureGrid {
            __typename
            ... on FeatureGrid {
              stateMetadata {
                primaryBillingGroupMetadata {
                  subscription {
                    id
                  }
                }
                userMetadata {
                  person {
                    primaryCalendarId
                    id
                  }
                  trialMetadata {
                    trialEndDate
                    timeZone
                  }
                }
              }
            }
            ... on GraphEntityError {
              statusCode
              message
            }
          }
          settings(first: 1000000) {
            edges {
              node {
                id
                key {
                  id
                  name
                  scope {
                    id
                    type
                    value
                  }
                  target {
                    id
                    type
                    value
                  }
                }
                type {
                  id
                  valueType
                  containerType
                  required
                }
                value
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment FastCrawlLoader_flowState on FlowState {
  id
  flowKey
  current {
    state
    percentComplete
    errorMessage
    id
  }
  pending {
    state
    percentComplete
    errorMessage
    id
  }
}

fragment FeedScheduler_org on Org {
  id
  domains
  primaryOrgEmail
  experiments
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      shadowCalendarId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  personsByCalendarIdsErrorable(calendarIds: []) {
    __typename
    ... on PersonList {
      list {
        id
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            (v2 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v5 = [
        (v4 /*: any*/)
    ], v6 = {
        "kind": "InlineFragment",
        "selections": (v5 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v7 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v8 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any,
        (v4 /*: any*/)
    ], v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v11 = [
        (v4 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
        } as any,
        (v10 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "ChromeFeedRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ChromeFeed_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ChromeFeedRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdTime",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "chromeExtensionFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v1 /*: any*/),
                                        (v3 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flags",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Flags",
                                            "abstractKey": null
                                        },
                                        (v6 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": "FlowStateConnection",
                                    "kind": "LinkedField",
                                    "name": "flowStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "flowKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "current",
                                                            "plural": false,
                                                            "selections": (v8 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "pending",
                                                            "plural": false,
                                                            "selections": (v8 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "flowStates(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v7 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v4 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "shadowCalendarSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "shadowCalendarId",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ShadowCalendarSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "calendarIds",
                                                                    "value": []
                                                                }
                                                            ],
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personsByCalendarIdsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Person",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "primaryEmail",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "UserProfile",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "profile",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v0 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "familyName",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "externalImageUrl",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isYou",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "PersonList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v2 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": "personsByCalendarIdsErrorable(calendarIds:[])"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgMeetingHours",
                                                            "kind": "LinkedField",
                                                            "name": "orgMeetingHours",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingHours",
                                                                    "kind": "LinkedField",
                                                                    "name": "workingHours",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v4 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "primaryTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "teamId",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "teamName",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Team",
                                                                    "abstractKey": null
                                                                },
                                                                (v3 /*: any*/),
                                                                (v6 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "featureGrid",
                                                            "plural": false,
                                                            "selections": [
                                                                (v1 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentStateMetadata",
                                                                            "kind": "LinkedField",
                                                                            "name": "stateMetadata",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "PrimaryBillingGroupMetadata",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "primaryBillingGroupMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "PaymentSubscription",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "subscription",
                                                                                            "plural": false,
                                                                                            "selections": (v5 /*: any*/),
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "UserMetadata",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "userMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "OrgPerson",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "person",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "primaryCalendarId",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v4 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "TrialMetadata",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "trialMetadata",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "trialEndDate",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v9 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FeatureGrid",
                                                                    "abstractKey": null
                                                                },
                                                                (v3 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v7 /*: any*/),
                                                            "concreteType": "SettingConnection",
                                                            "kind": "LinkedField",
                                                            "name": "settings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "SettingEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Setting",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SettingKey",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "key",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "name",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Urn",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "scope",
                                                                                            "plural": false,
                                                                                            "selections": (v11 /*: any*/),
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "Urn",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "target",
                                                                                            "plural": false,
                                                                                            "selections": (v11 /*: any*/),
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SettingType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "type",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "valueType",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "containerType",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "required",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v10 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "settings(first:1000000)"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v4 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "d93f9afb8c663d598c2478ed4a8f8a6b",
            "id": null,
            "metadata": {},
            "name": "ChromeFeedRendererQuery",
            "operationKind": "query",
            "text": "query ChromeFeedRendererQuery {\n  viewer {\n    ...ChromeFeed_viewer\n    id\n  }\n}\n\nfragment ChromeFeed_viewer on Viewer {\n  user {\n    givenName\n    createdTime\n    chromeExtensionFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          ...FastCrawlLoader_flowState\n          flowKey\n          current {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n          pending {\n            state\n            percentComplete\n            errorMessage\n            id\n          }\n          id\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          ...FeedScheduler_org\n          orgMeetingHours {\n            workingHours {\n              timeZone\n              id\n            }\n            id\n          }\n          experiments\n          primaryTeam {\n            __typename\n            ... on Team {\n              teamId\n              teamName\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          featureGrid {\n            __typename\n            ... on FeatureGrid {\n              stateMetadata {\n                primaryBillingGroupMetadata {\n                  subscription {\n                    id\n                  }\n                }\n                userMetadata {\n                  person {\n                    primaryCalendarId\n                    id\n                  }\n                  trialMetadata {\n                    trialEndDate\n                    timeZone\n                  }\n                }\n              }\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n          }\n          settings(first: 1000000) {\n            edges {\n              node {\n                id\n                key {\n                  id\n                  name\n                  scope {\n                    id\n                    type\n                    value\n                  }\n                  target {\n                    id\n                    type\n                    value\n                  }\n                }\n                type {\n                  id\n                  valueType\n                  containerType\n                  required\n                }\n                value\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment FastCrawlLoader_flowState on FlowState {\n  id\n  flowKey\n  current {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n  pending {\n    state\n    percentComplete\n    errorMessage\n    id\n  }\n}\n\nfragment FeedScheduler_org on Org {\n  id\n  domains\n  primaryOrgEmail\n  experiments\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      shadowCalendarId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  personsByCalendarIdsErrorable(calendarIds: []) {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '476276175f00a4b8f0e9d6e403e50983';
export default node;
